import { Inject, Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';

@Injectable({
  providedIn: 'root'
})
export class SignalrService {
  hubConnection!: signalR.HubConnection;
  private readonly hubName: string;

  constructor(@Inject(String) hubName: string) {
    this.hubName = hubName;
  }

  async startConnection(userId: string): Promise<void> {
    if (this.hubConnection) {
      await this.stopConnection();
    }
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`http://localhost:5260/${this.hubName}?userId=${userId}`)
      .withAutomaticReconnect()
      .build();

    this.listenForEvents();
    await this.hubConnection.start();
  }

  async stopConnection(): Promise<void> {
    if (this.hubConnection?.state !== signalR.HubConnectionState.Disconnected) {
      await this.hubConnection.stop();
    }
  }

  isConnected(): boolean {
    return this.hubConnection?.state === signalR.HubConnectionState.Connected;
  }

  async ensureConnection(): Promise<void> {
    if (!this.isConnected()) {
      await this.hubConnection.start();
    }
  }

  protected listenForEvents(): void {
  }
}
